// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateMalaysianDuitNowBankCode(selectedPaymentMethod: string, selectedEwallet: string, bankCodeValue: string): ?UserInputValidationError {
  if (
    selectedPaymentMethod === 'ewallet'
    && selectedEwallet === 'duitnow-pay'
    && (bankCodeValue === '' || bankCodeValue === null || bankCodeValue === undefined)
  ) {
    return {id: 'empty'};
  }
}
